import { Select, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect } from "react";

const SelectOrganization = observer(() => {
  const { pageStore } = useStores();
  useEffect(() => {
    pageStore.updateSelectedOrganiztion("");
  }, []);
  return (
    <VStack>
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
          fontSize: "14px"
        }}
        placeholder="Все организации"
        width={"200px"}
        value={pageStore.selected_organization || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedOrganiztion(selectedValue || "");
        }}
      >
        {pageStore.all_orgs.length > 0 &&
          pageStore.all_orgs?.map((item, index) => (
            <option
              style={{ background: "#0C0C0C", color: "#EEEEEE" }}
              value={item?.Org}
              key={index}
            >
              {item?.Org}
            </option>
          ))}
      </Select>
    </VStack>
  );
});

export default SelectOrganization;
